export default "__VITE_ASSET__BaSPpwG1__"